/**
 * Initialises owl carousels and custom owl carousels.
 */
(function (jQuery) {
  'use strict';
  function ProjectsAbroadOwlCarousel () {
    var global = {
      baseOptions: {
        loop: false,
        dots: true,
        nav: true,
        navText: [
          '<i class="icon-arrow-left"></i>',
          '<i class="icon-arrow-right"></i>',
        ],
        responsive: false,
        checkVisibility: false,
      },
      customOwlOptions: {
        mouseDrag: false,
        touchDrag: false,
        items: 1,
        nav: false,
        dots: false,
      },
      owlSelector: '.owl-carousel',
      transformMatrixXIndex: undefined,
    };

    var fn = {
      /**
			 * Initiate owl carousels and load custom owl carousels.
			 */
      init: function () {
        // The transform css property is returned as a matrix, where the 4th number is the x value, except on ie11, where it is the 13th for some reason :/
        global.transformMatrixXIndex = window.navigator.userAgent.indexOf (
          'Trident/7.0'
        ) > 0
          ? 13
          : 4;

        global.baseOptions['onRefreshed'] = fn.updateItemHeights;
        global.baseOptions['onResized'] = fn.updateItemHeights;

        /* Internal Link Snippets carousel */
        fn.loadCarousels ('.Gallery--internal-link-snippets', {
          autoWidth: true,
          nav: false,
          margin: 40,
          items: 1,
        });

        /* Team carousel */
        fn.loadCarousels ('.Gallery--team', {
          responsive: {
            0: {
              margin: 20,
              stagePadding: 70,
              items: 1,
              nav: false,
              dots: false,
            },
            576: {
              margin: 30,
              stagePadding: 70,
              items: 2,
              nav: false,
              dots: false,
            },
            768: {margin: 30, stagePadding: 100, items: 3, dots: false},
            992: {margin: 40, stagePadding: 100, items: 4, dots: false},
            1200: {margin: 30, stagePadding: 200, dots: false},
            1600: {margin: 40, stagePadding: 300, dots: false},
            1900: {margin: 50, stagePadding: 350, items: 5, dots: false},
          },
        });

        /* TripFormat carousel */
        fn.loadCarousels ('.Gallery--trip', {
          responsive: {
            0: {margin: 20, stagePadding: 20, items: 1, dots: false},
            576: {margin: 30, stagePadding: 30, items: 1, dots: false},
            768: {margin: 70, stagePadding: 140, items: 2, dots: false},
            992: {margin: 50, stagePadding: 100, items: 3, dots: false},
            1200: {margin: 30, stagePadding: 100, items: 4, dots: false},
            1600: {margin: 40, stagePadding: 180, items: 4, dots: false},
            1900: {margin: 100, stagePadding: 200, items: 4, dots: false},
          },
        });

        /* Recently viewed carousel */
        fn.loadCarousels ('.Gallery-recently', {
          responsive: {
            0: {items: 1, stagePadding: 30, margin: 30, nav: false},
            800: {items: 3, stagePadding: 100, margin: 30},
            1600: {items: 4, stagePadding: 400, margin: 30},
          },
        });

        /* Volunteer reviews carousel */
        fn.loadCarousels ('.Gallery--reviews', {
          margin: 30,
          center: false,
          items: 2,
          slideBy: 2,
          responsive: {
            0: {items: 1, stagePadding: 10},
            800: {items: 2, stagePadding: 30},
            1100: {items: 2, stagePadding: 70},
            1200: {items: 2, stagePadding: 150},
            1600: {items: 2, stagePadding: 200, margin: 30},
            1800: {items: 2, stagePadding: 300, margin: 30},
            1900: {items: 2, stagePadding: 400, margin: 30},
            2100: {items: 2, stagePadding: 500, margin: 30},
            2400: {items: 2, stagePadding: 650, margin: 30},
          },
        });

        /* Volunteer sidebar reviews carousel */
        fn.loadCarousels ('.Gallery--sidebar-reviews', {
          items: 1,
        });

        /* Interns carousel */
        fn.loadCarousels('.Gallery--default', {
          autoWidth: true, // fit to custom styles
          responsive: {
            0: {margin: 16, nav: false},
            576: {margin: 20, nav: false},
            768: {margin: 25},
            992: {margin: 30},
            1200: {margin: 35},
          },
        });

        // Position carousel using negative right position
        // this avoids setting stage padding and margin-right for each breakpoint
        // and allows us to change the image sizes
        fn.positionCarousels();
        jQuery(window).resize(fn.positionCarousels);

        /* Accreditations carousel */
        fn.loadCarousels ('.Gallery--accreditations', {
          merge: true,
          mergeFit: true,
          items: 10,
          stagePadding: 100,
          responsive: {
            0: {
              margin: 16,
              nav: false,
              items: 20,
              stagePadding: 0,
              touchDrag: false,
              mouseDrag: false,
            },
            768: {
              nav: false,
              items: 20,
              stagePadding: 0,
              touchDrag: false,
              mouseDrag: false,
            },
            992: {margin: 30, items: 4, stagePadding: 60},
            1200: {margin: 50, items: 6, stagePadding: 70},
            1600: {margin: 50, items: 7, stagePadding: 80},
            1800: {margin: 50, items: 8, stagePadding: 90},
          },
        });
      },

      /**
			 * Load carousels with the given selector with the given options.
			 */
      loadCarousels: function (selector, options) {
        var owlElems = jQuery (global.owlSelector + selector);
        if (!owlElems.length) {
          return;
        }

        var opts = Object.create (global.baseOptions);
        Object.keys (options).forEach (key => (opts[key] = options[key]));

        // Create settings object for if a carousel of this type is a custom carousel, where certain options are set for the custom carousel to work.
        var customOpts = Object.create (opts);
        Object.keys (global.customOwlOptions).forEach (
          key => (customOpts[key] = global.customOwlOptions[key])
        );

        owlElems.each (function (_, owl) {
          var owl = jQuery (owl);

          // Only load carousel if it has at least one item.
          var carouselLength = owl.find ('.Gallery__item').length;
          if (carouselLength > 0) {
            if (carouselLength === 1) {
              opts.mouseDrag = false;
              opts.touchDrag = false;
              opts.pullDrag = false;
            }

            if (owl.hasClass ('custom-owl-carousel')) {
              owl.owlCarousel (customOpts);
              fn.loadCustomOwl (owl);
            } else {
              owl.owlCarousel (opts);
            }
          }
        });

        if (typeof document.fonts === 'object') {
          document.fonts.ready.then (function () {
            /*
						 * We've got the font-loading set to swap, and so the original layout may be calculated with a fallback font
						 * Once the real font is loaded, the sizes may have changed, so trigger a re-layout.
						 *
						 * This will only work in some browsers, but older browsers will use the "block" method of font loading,
						 * which are less likely to be impact by the font-load event.
						 */
            owlElems.trigger ('refresh.owl.carousel');
          });
        }
      },

      /**
			 * Loads custom modifications to owl carousels, with different dots and navigation behaviour.
			 * A dot is created for each item, and remain visible and functional when all items in the carousel fit in the screen.
			 */
      loadCustomOwl: function (owl) {
        var items = owl.find ('.owl-item');
        var stage = owl.find ('.owl-stage');

        // Add custom nav elements
        owl.append (
          '<div class="owl-nav custom-owl-nav">' +
            '<div class="owl-prev custom-owl-nav disabled">' +
            '<i class="icon-arrow-left"></i>' +
            '</div>' +
            '<div class="owl-next custom-owl-nav' +
            (items.length > 1 ? '' : ' disabled') +
            '">' +
            '<i class="icon-arrow-right"></i>' +
            '</div>' +
            '</div>'
        );

        var nav = owl.find ('.owl-nav');
        var navprev = nav.find ('.custom-owl-nav.owl-prev');
        var navnext = nav.find ('.custom-owl-nav.owl-next');

        // Add custom dots
        var ndots = '';
        for (var i = items.length - 1; i; i--)
          ndots += '<div class="owl-dot"><span></span></div>';
        owl.append (
          '<div class="owl-dots custom-owl-dots">' +
            '<div class="owl-dot active"><span></span></div>' +
            ndots +
            '</div>'
        );

        var dots = owl.find ('.custom-owl-dots .owl-dot');

        // Add click event listeners to custom dots and nav buttons.
        dots.each (function (index, dot) {
          jQuery (dot).on ('click', function (e) {
            fn.spinCarousel (owl, stage, items, dots, index, 800);
          });
        });

        navprev.on ('click', function (e) {
          var index = dots.filter ('.active').prevAll ('.owl-dot').length - 1;
          if (index >= 0) {
            fn.spinCarousel (owl, stage, items, dots, index, 400);
          }
        });
        navnext.on ('click', function (e) {
          var index = dots.filter ('.active').prevAll ('.owl-dot').length + 1;
          if (index < dots.length) {
            fn.spinCarousel (owl, stage, items, dots, index, 400);
          }
        });

        // Update if the nav buttons are disabled or not after the carousel is translated.
        owl.on ('translate.owl.carousel', function () {
          var index = dots.filter ('.active').prevAll ('.owl-dot').length;

          if (index === 0) {
            navprev.addClass ('disabled');
          } else {
            navprev.removeClass ('disabled');
          }

          if (index === dots.length - 1) {
            navnext.addClass ('disabled');
          } else {
            navnext.removeClass ('disabled');
          }
        });

        fn.makeDragabble (owl, stage, items, dots);
      },

      /**
			 * Aligns the default carousel with the dynamicly positioned raw content
			 */
      positionCarousels: function () {
        jQuery('.Gallery--default, .TypeBlock').each(function (index, gallery) { 
          var rawContentOffset = jQuery(gallery)
          .closest('.TypeText')
          .find('.RawContent')
          .first()
            .offset();
          
          var rawContentLeft = rawContentOffset ? rawContentOffset.left : 0;
          
          jQuery(gallery)
          .find('.owl-stage')
          .css('right', (rawContentLeft * -1) + 'px');
        });
      },

      updateItemHeights: function (event) {
        var currentCarousel = $ (event.target);
        currentCarousel.find ('.Gallery__item').css ('height', '');

        var heights = currentCarousel
          .find ('.Gallery__item')
          .map (function () {
            return $ (this).outerHeight ();
          })
          .get (),
          maxHeight = Math.max.apply (null, heights);

        currentCarousel
          .find ('.Gallery__item')
          .css ('height', maxHeight + 'px');
      },

      /**
			 * Makes a custom carousel draggable with correct behaviour.
			 */
      makeDragabble: function (owl, stage, items, dots) {
        var _window = jQuery (window);
        var outerstage = stage.parent ();

        // Stop links being triggered on dragging by adding and removing this event handler to the links when dragging the carousel starts and stops.
        var stopOpenLinkOnDrag = function (e) {
          e.preventDefault ();
        };
        var links = stage.find ('a');

        // Track the state of if the mouse is dragging or not, and its last position.
        var mdown = false;
        var mlastpos = 0;
        var startpos = 0;

        outerstage.on ('mousedown touchstart', function (e) {
          mdown = true;
          mlastpos = e.clientX;
          startpos = fn.getStagePosition (stage);
        });
        // Stop items being dragged natively
        outerstage.on ('dragstart', function (e) {
          e.preventDefault ();
          links.on ('click', stopOpenLinkOnDrag);
        });
        _window.on ('mouseup touchend touchcancel', function (e) {
          if (mdown) {
            mdown = false;

            var pos = fn.getStagePosition (stage);
            var dis = pos - startpos;

            var startItemIndex = fn.getClosestItemToPosition (items, startpos);
            var currItemIndex = fn.getClosestItemToPosition (items, pos);
            var startItem = jQuery (items.get (startItemIndex));
            var startItemWidth = startItem.outerWidth (true);
            var minMoveDis = startItemWidth * 0.1;

            // Set the item to spin to to be the current item the carousel is on.
            var itemToSpinTo = currItemIndex;
            // If the distance moved is less than the width of the item the carousel was on when the drag started
            // and greater than the minimum move distance, move the carousel one item in the appropriate direction.
            if (Math.abs (dis) < startItemWidth) {
              if (dis > minMoveDis) itemToSpinTo = startItemIndex + 1;
              if (dis < -minMoveDis) itemToSpinTo = startItemIndex - 1;
            }

            // Snap the carousel to the nearest item after drag.
            fn.spinCarousel (
              owl,
              stage,
              items,
              dots,
              itemToSpinTo,
              400,
              function () {
                links.off ('click', stopOpenLinkOnDrag);
              }
            );
          }
        });
        _window.on ('mousemove touchmove', function (e) {
          if (mdown) {
            var maxdragpos = jQuery (items.get (items.length - 1)).position ()
              .left;
            var mnewpos = e.clientX || e.touches[0].clientX;
            var oldPos = -fn.getStagePosition (stage);
            var newPos = oldPos + (mnewpos - mlastpos);

            if (newPos < 0 && newPos > -maxdragpos) {
              stage.css (
                'transform',
                'translate3d(' + newPos + 'px, 0px, 0px)'
              );
            }
            mlastpos = mnewpos;
          }
        });
      },

      /**
			 * Spins the carousel to the item at the index given.
			 */
      spinCarousel: function (
        owl,
        stage,
        items,
        dots,
        index,
        duration,
        callback
      ) {
        stage.stop ();

        // Count all of the owl-dots before the current active dot in the DOM within the dot container to work out the old index.
        var oldIndex = dots.filter ('.active').prevAll ('.owl-dot').length;
        var oldPosition = -fn.getStagePosition (stage);
        var item = jQuery (items.get (index));

        fn.updateActiveItems (items, dots, index, oldIndex);
        owl.trigger ('translate');

        stage.animate (
          {_: -item.position ().left},
          {
            step: function (now, fx) {
              fx.start = oldPosition;
              jQuery (this).css (
                'transform',
                'translate3d(' + now + 'px, 0px, 0px)'
              );
            },
            done: function () {
              owl.trigger ('translated');
              if (callback) callback ();
            },
            duration: duration,
          }
        );
      },

      /**
			 * Returns the index of the closet item to the position given.
			 */
      getClosestItemToPosition: function (items, pos) {
        var closest = 0;
        pos += 20;
        for (var i = 0; i < items.length; i++) {
          var itemLeft = jQuery (items[i]).position ().left;
          if (itemLeft < pos) closest = i;
          if (itemLeft > pos) break;
        }

        return closest;
      },

      /**
			 * Gets the current position of the stage.
			 */
      getStagePosition: function (stage) {
        // The transform css property is returned as a matrix, so get the appropriate value using a regex match.
        return Number (
          stage.css ('transform').match (/\d+/g)[global.transformMatrixXIndex]
        );
      },

      /**
			 * Update the active items and dots according to the indicies given.
			 */
      updateActiveItems: function (items, dots, index, oldIndex) {
        jQuery (dots.get (oldIndex)).removeClass ('active');
        jQuery (dots.get (index)).addClass ('active');
        jQuery (items.get (oldIndex)).removeClass ('active');
        jQuery (items.get (index)).addClass ('active');
      },
    };

    jQuery(fn.init);
  }

  new ProjectsAbroadOwlCarousel ();
}) ($);
